import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import RegistOrLogin from './RegistOrLogin';
import { Box, Snackbar } from '@mui/material';

function getStyle(iconValue){
    const style = [
        {cursor:"pointer",color:"#333333"},
        {cursor:"pointer",color:"#000000"}
    ];
    if(iconValue){
        return style[0];
    } else {
        return style[1];
    }
}

const FavoriteIcon = (props) => {
    const {t,i18n} = useTranslation()
    const [iconValue,setState] = useState(false)

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [count,setCount] = useState(props.count || 0)
    const [open,setOpen] = useState(false)
    const [favMessage,setFavMessage] = useState("")

    useEffect(() =>{
        setState(props.favorite)
        setCount(props.count || 0)
    },[props.favorite,props.id,props.count])

    function changeStyle(b){
        if(loginInfo.length == 0 || !loginInfo.result){
            props.dialog("エラー","お気に入り登録するにはログインする必要があります。")
            return
        }
        if(b){
            new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/"+props.type+"/"+props.id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        setState(b)
                        if(json.data && json.data.message !== ""){
                            setOpen(true)
                            setFavMessage(json.data.message)
                        }
                    } else {
                        setCount(props.count || 0)
                        props.dialog("エラー",json.errors)
                        setOpen(false)
                    }
                })  
            });
        } else {
            new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/"+props.type+"/"+props.id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        setState(b);
                    } else {
                        setCount(props.count || 0)
                        props.dialog("エラー",json.errors)
                    }
                })  
            });
        }
    }   

    if(iconValue){
        return   <>
        <Snackbar
            anchorOrigin={{ vertical:"botom", horizontal:"left" }}
            open={open}
            onClose={() => setOpen(false)}
            message={favMessage}
            key={"bottomleft"}
        />
        <Badge bg="white" onClick={(e) => {
            e.stopPropagation()
            changeStyle(!iconValue)
            if(count !== -1) setCount(parseInt(count)-1)
        }} style={props.style}><Icon.HandThumbsUpFill style={getStyle(iconValue)}/> <span style={{fontSize:"14px",color:"#555555",display:count === 0 || count === -1 ? "none" : "inline"}}>{count}</span></Badge></>
    } else {
        return   <Badge bg="white" onClick={(e) => {
            e.stopPropagation()
            if(loginInfo.result === false){
                props.dialog(t("common.loginToContinue"),<RegistOrLogin dialog={props.dialog} />)
                return
            }
            changeStyle(!iconValue)
            if(count !== -1) setCount(parseInt(count)+1)
        }} style={props.style}><Icon.HandThumbsUp style={getStyle(iconValue)}/> <span style={{fontSize:"14px",color:"#555555",display:count === 0 || count === -1 ? "none" : "inline"}}>{count}</span></Badge>
    }

}

export default FavoriteIcon;